(function () {
  'use strict';

  var TEMPLATE_PRODUCT = 'product';
  // Store-specific display routing. Empty suffix means Shopify's Default product template.
  var RULE_TEMPLATE_SUFFIXES = {
    '6322': ['umedmart-fresh'],
    '6323': ['']
  };
  var config = { debug: true };
  if (window.SalepifyPgbProductRuleSelectorConfig && typeof window.SalepifyPgbProductRuleSelectorConfig === 'object') {
    config.debug = window.SalepifyPgbProductRuleSelectorConfig.debug !== false;
  }
  var state = { filtered: false, reason: 'not-run', keptRuleIds: [] };

  function log(label, payload) {
    if (!config.debug) return;
    var console = window.console;
    if (console && typeof console.log === 'function') {
      console.log('[Salepify PGB scope] ' + label, payload);
    }
  }

  function id(value) {
    if (value === null || value === undefined) return '';
    return String(value).split('/').pop();
  }

  function ruleId(key, rule) {
    return String(key).split('_')[0] || id(rule && rule.id);
  }

  function matchesTemplate(ruleKey, rule, templateSuffix) {
    var allowedSuffixes = RULE_TEMPLATE_SUFFIXES[ruleId(ruleKey, rule)];
    return !allowedSuffixes || allowedSuffixes.indexOf(templateSuffix) !== -1;
  }

  function productScope() {
    var scope = window.SalepifyPgbProductScope;
    // The custom script deliberately runs before the app embed. At that point
    // tlCartGoalTemplate is not assigned yet, so Liquid scope is authoritative.
    if (window.tlCartGoalTemplate && window.tlCartGoalTemplate !== TEMPLATE_PRODUCT) {
      state.reason = 'not-product-page';
      log('skip: not a product page', { template: window.tlCartGoalTemplate });
      return null;
    }

    var templateSuffix = typeof (scope && scope.templateSuffix) === 'string'
      ? scope.templateSuffix
      : '';

    if (!scope || !Object.prototype.hasOwnProperty.call(scope, 'templateSuffix')) {
      state.reason = 'missing-template-scope';
      log('skip: missing template scope', scope);
      return null;
    }
    log('template scope', { templateSuffix: templateSuffix });
    return { templateSuffix: templateSuffix };
  }

  function filterRules(rules, scope) {
    if (!rules || typeof rules !== 'object' || Array.isArray(rules)) {
      state.reason = 'invalid-rules';
      log('skip: invalid rules payload', rules);
      return rules;
    }

    // Keep the unfiltered payload for the cart-display-only custom. It never
    // changes this product-page selector or the app's selected product rule.
    window.SalepifyPgbRawRules = rules;
    var selected = {};
    var rejectedRuleIds = [];
    state.keptRuleIds = [];
    Object.keys(rules).forEach(function (key) {
      var rule = rules[key];
      if (matchesTemplate(key, rule, scope.templateSuffix)) {
        selected[key] = rule;
        state.keptRuleIds.push(ruleId(key, rule));
      } else {
        rejectedRuleIds.push(ruleId(key, rule));
      }
    });

    state.filtered = true;
    state.reason = 'filtered';
    log('filtered rules', { keptRuleIds: state.keptRuleIds, rejectedRuleIds: rejectedRuleIds });
    return selected;
  }

  function waitForRules(scope) {
    var storedRules;
    try {
      Object.defineProperty(window, 'tlCartGoalRules', {
        configurable: false,
        get: function () { return storedRules; },
        set: function (rules) { storedRules = filterRules(rules, scope); }
      });
      state.reason = 'waiting-for-rules';
      log('waiting for tlCartGoalRules assignment', null);
    } catch (_error) {
      // Fail open: a storefront must not break if another script owns this global.
      state.reason = 'could-not-wait-for-rules';
      log('could not install rule hook', _error);
    }
  }

  try {
    var scope = productScope();
    if (scope) {
      if (window.tlCartGoalRules && typeof window.tlCartGoalRules === 'object') {
        window.tlCartGoalRules = filterRules(window.tlCartGoalRules, scope);
      } else {
        waitForRules(scope);
      }
    }
  } catch (_error) {
    // Fail open: this store-specific enhancement must never interrupt theme/app scripts.
    state.reason = 'bootstrap-error';
    log('bootstrap error; custom disabled', _error);
  }
  window.SalepifyPgbProductRuleSelector = {
    inspect: function () { return Object.assign({}, state, { keptRuleIds: state.keptRuleIds.slice(), debug: config.debug }); }
  };
}());
